module.exports = __webpack_public_path__ + "img/75751.0fbc1780.svg";